export const httpConstants = {
  METHOD_TYPE: { POST: "POST", PUT: "PUT", GET: "GET", DELETE: "DELETE" },
  CONTENT_TYPE: {
    APPLICATION_JSON: "application/json",
    MULTIPART_FORM_DATA: "multipart/form-data",
    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
    IMAGE_PNG: "image/png"
  },
  DEVICE_TYPE: { WEB: "web" },
  API_END_POINT: {
    PROCESSED_CLAIMS_LIST: "/claims",
    CLAIM_RECORD: "/claims/records",
    COMMERCIAL_RECORD: "/claims/records/commercial",
    CLAIM_FEEDBACK: "/feedback",
    PROCESSED_CLAIM_DETAILS: "/details",
    REPAIR: "/repair",
    PROCESSED_CLAIM_DETAILS_RECORD: "/records",
    UPDATE_FEEDBACK: "/claims/feedback",
    INSPECTION_IMAGES: "/inspection-images",
    CLAIMS: "/claims",
    REPORT: "/report",
    NON_COMMERCIAL: "/non-commercial",
    REPAIR_LIST: "/repairFirst/claims",
    REPAIR_DETAILS: "/repairFirst/claims",
    REPAIR_INSPECTION_IMAGES: "/repairFirst/claims",
    REPAIR_FEEDBACK: "/repairFirst/claims/feedback",
    UPDATE_REPAIR_FEEDBACK: "/repairFirst/claims/feedback",
    INSPECTION_REPORT: "/repairFirst/claims/report",
    IMAGE_TAG: "/image-tags",
    OVERRIDE_API: "/repairFirst/claims/overridden",
    OVERRIDE_DETAILS: "/repairFirst/claims/overridden",
    OVERRIDE_IMAGES: "/repairFirst/claims/overridden"
  }
};

export const formConstants = {
  ACTION_TYPES: {
    UDPATE_STATE: "UDPATE_STATE"
  }
};

export const keyConstants = {
  USER: "user",
  SCOPES: ["openid", "profile", "email"],
  TOKEN: "auth_token",
  INCORRECT_AI_RESPONSE: "INCORRECT_AI_RESPONSE",
  INCORRECT_DATA_IMAGE: "INCORRECT_DATA_IMAGE",
  CORRECT: "CORRECT",
  CORRECTLY_OVERRIDDEN_GEN_AI_INCORRECT:
    "CORRECTLY_OVERRIDDEN_GEN_AI_INCORRECT",
  INCORRECTLY_OVERRIDDEN_GEN_AI_CORRECT:
    "INCORRECTLY_OVERRIDDEN_GEN_AI_CORRECT",
  INCORRECT_DATA_IN_OVERRIDDEN: "INCORRECT_DATA_IN_OVERRIDDEN",
  CORRECTLY_ACCEPTED_GEN_AI_CORRECT: "CORRECTLY_ACCEPTED_GEN_AI_CORRECT",
  INCORRECTLY_ACCEPTED_GEN_AI_INCORRECT:
    "INCORRECTLY_ACCEPTED_GEN_AI_INCORRECT",
  INCORRECT_DATA_IN_ACCEPTED: "INCORRECT_DATA_IN_ACCEPTED",
  CORRECTLY_OVERRIDDEN_GEN_AI_CORRECT: "CORRECTLY_OVERRIDDEN_GEN_AI_CORRECT",
  INCORRECTLY_ACCEPTED_GEN_AI_CORRECT: "INCORRECTLY_ACCEPTED_GEN_AI_CORRECT",
  GEN_AI_CORRECT_INSUFFICIENT_INPUTS: "GEN_AI_CORRECT_INSUFFICIENT_INPUTS"
};

export const tireComponent = {
  leftRearTire: "LEFT REAR TIRE",
  leftFrontTire: "LEFT FRONT TIRE",
  rightRearTire: "RIGHT REAR TIRE",
  rightFrontTire: "RIGHT FRONT TIRE",
  leftRearWheel: "LEFT REAR WHEEL",
  leftFrontWheel: "LEFT FRONT WHEEL",
  rightRearWheel: "RIGHT REAR WHEEL",
  rightFrontWheel: "RIGHT FRONT WHEEL"
};

export const questionsText = {
  "Object Location": "What is the location of the object in the tire?",
  "Hole Location": "What is the location of the hole in the tire?",
  "Cut/Slice Location": "What is the Location of Cut or Slice in the tire",
  "Hole Present": "Is there a hole in the tire?",
  "Cut/Slice Present": "Are there any Cut or Slice in the tire"
};
